import { excludeHtmlTagsFromString } from "./utils";

const TEXT_ELEMENTS = ["H1", "H2", "H3", "H4", "H5", "H6", "SPAN", "DIV", "P"];

/*==============================================================================================
getText() returns the node value for a given node specified by the 'path' param.
Returns an empty string if no matching node is found.
==============================================================================================*/
function getText(path, languageData) {
  let val = "";
  const tokens = path.split(".");
  if (tokens && tokens.length > 0) {
    val = languageData[tokens[0]] || "";
    if (tokens.length > 1) {
      for (let i = 1; i < tokens.length; i++) {
        if(val[tokens[i]]){
          val = val[tokens[i]];
        } else {
          //console.log('Missing lang tag ' + path );
        }
      }
    }
  }

  return val;
}

/*==============================================================================================
localize() applies text from language node corresponding to each element's 'data-ref' attribute..
If altRef is specified, only alt attribute is updated.
==============================================================================================*/
export default function localize(el, languageData, altRef) {
  if (el.getAttribute) {
    //const langToken = el.getAttribute('data-ref');
    const langToken = altRef
      ? el.getAttribute(altRef)
      : el.getAttribute("data-ref");

    if (langToken) {
      const text =
        getText(langToken, languageData) || "_" + langToken + "_" || "";
      const span = el.querySelector("span");
      let isContainText = true;
      const hasGraphic = el.querySelector("img") || el.querySelector("svg");
      const tagName = el.tagName;

      // Setting up title on all elements with data-ref
      // having 'no-title' attribute on elements where we don't want the title
      if (el.getAttribute("no-title") == null) {
        el.setAttribute("title", excludeHtmlTagsFromString(text));
      }

      // alt text on IMG
      if (tagName === "IMG") {
        el.setAttribute("alt", excludeHtmlTagsFromString(text));
        isContainText = false;
      }

      // check if it contains span - append text in span
      if (el.contains(span)) {
        isContainText = false;
        span.innerHTML = text;
      }

      /* ---------- FORM ELEMENTS SPECIFIC -------------  */

      if (tagName === "BUTTON" && !hasGraphic) {
        el.setAttribute("value", text);
      }

      if (tagName === "SELECT") {
        isContainText = false;
      }

      // input will have placeholder
      if (tagName === "INPUT") {
        el.setAttribute("placeholder", excludeHtmlTagsFromString(text));
        isContainText = false;

        // submit or reset button - will set value to it
        if (
          el.type.toLowerCase() === "submit" ||
          el.type.toLowerCase() === "button" ||
          el.type.toLowerCase() === "reset"
        ) {
          el.setAttribute("value", excludeHtmlTagsFromString(text));
        }
      }

      // textarea will also contain placeholder
      if (tagName === "TEXTAREA") {
        el.setAttribute("placeholder", excludeHtmlTagsFromString(text));
        isContainText = false;
      }
      /* ---------- FORM ELEMENTS SPECIFIC -------------  */

      // don't add text if element is not capable to show text (IMG, INPUT)
      if (isContainText && !hasGraphic) {
        el.innerHTML = text;
      }
    }

    if (
      languageData.LanguageId &&
      languageData.LanguageId.indexOf("ar-") > -1
    ) {
      if (TEXT_ELEMENTS.indexOf(el.nodeName)) {
        this.setAttribute("dir", "rtl");
      }
    }
  }

  //update nodes within el
  if (el.childNodes) {
    for (const node of el.childNodes) {
      localize(node, languageData);
    }
  }
}
